<div class="credit-card" [class]="statusClass">
  <div class="card-header">
    <div class="header-info">
      <i class="pi pi-map-marker"></i>
      <h3>Información de Domicilio</h3>
    </div>
    <div class="completion-indicator">
      <span class="percentage">{{ completionPercentage }}%</span>
      <div class="progress-bar">
        <div class="progress-fill" [style.width.%]="completionPercentage"></div>
      </div>
    </div>
  </div>

  <div class="card-content">
    <div *ngIf="!hasData" class="no-data">
      <i class="pi pi-home"></i>
      <p>No hay información de domicilio disponible</p>
    </div>

    <div *ngIf="hasData" class="data-sections">
      <!-- Dirección Principal -->
      <div class="section">
        <h4 class="section-title">Dirección</h4>
        <div class="data-grid">
          <div class="data-item featured">
            <label>Dirección Completa:</label>
            <span class="value address-full">{{ fullAddress }}</span>
          </div>

          <div class="data-item" [class.empty]="!data?.address">
            <label>Dirección:</label>
            <span [class]="data?.address ? 'value' : 'placeholder'">
              {{ data?.address || 'No especificado' }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.neighborhood">
            <label>Colonia:</label>
            <span [class]="data?.neighborhood ? 'value' : 'placeholder'">
              {{ data?.neighborhood || 'No especificado' }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.municipality">
            <label>Municipio:</label>
            <span [class]="data?.municipality ? 'value' : 'placeholder'">
              {{ data?.municipality || 'No especificado' }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.city">
            <label>Ciudad:</label>
            <span [class]="data?.city ? 'value' : 'placeholder'">
              {{ data?.city || 'No especificado' }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.state">
            <label>Estado:</label>
            <span [class]="data?.state ? 'value' : 'placeholder'">
              {{ data?.state || 'No especificado' }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.postalCode">
            <label>Código Postal:</label>
            <span [class]="data?.postalCode ? 'value' : 'placeholder'">
              {{ data?.postalCode || 'No especificado' }}
            </span>
          </div>
        </div>
      </div>

      <!-- Información Adicional -->
      <div class="section">
        <h4 class="section-title">Información Adicional</h4>
        <div class="data-grid">
          <div class="data-item" [class.empty]="!data?.phoneNumber">
            <label>Teléfono:</label>
            <span [class]="data?.phoneNumber ? 'value' : 'placeholder'">
              {{ formatPhone(data?.phoneNumber) }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.residenceDate">
            <label>Fecha de Residencia:</label>
            <span [class]="data?.residenceDate ? 'value' : 'placeholder'">
              {{ formatDate(data?.residenceDate) }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.addressType">
            <label>Tipo de Dirección:</label>
            <span [class]="data?.addressType ? 'value' : 'placeholder'">
              {{ data?.addressType || 'No especificado' }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.settlementType">
            <label>Tipo de Asentamiento:</label>
            <span [class]="data?.settlementType ? 'value' : 'placeholder'">
              {{ data?.settlementType || 'No especificado' }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.addressOrigin">
            <label>Origen de Dirección:</label>
            <span [class]="data?.addressOrigin ? 'value' : 'placeholder'">
              {{ data?.addressOrigin || 'No especificado' }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
